export default {
    previous: 'Previous page',
    next: 'Next page',
    gap: 'More pages',
    renderPage: page => `Page ${page}`,
};
